import CLSSlogo from "../../Images/HapPlants .jpg";
import { NavLink } from "react-router-dom";
import React, { useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import "bootstrap/dist/css/bootstrap.css";
import "./Header.css";
import { Button } from "primereact/button";
import { useNavigate, useLocation } from "react-router-dom";
import GlobalPopup from "../../GlobalComponents/GlobalPopup";

export default function Header() {
  const [getlocalstorageusername, setlocalstorageusername] = useState(
    localStorage.getItem("logginuser")
  );
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isLogoutOpenPOpup, setIsLogoutOpenPopup] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // Channel switch function
  const SwithChannel = () => {
    localStorage.setItem("Detail", "ChannelDetail");
    navigate("/ChannelPopup");
  };

  // Check active route
  const isActive = (path) => location.pathname.startsWith(path);

  // LogOut confirmation function
  const LogOutButton = () => {
    setIsLogoutOpenPopup(true);
  };

  // Fullscreen toggle
  const toggleFullScreen = () => {
    if (isFullScreen) {
      document.exitFullscreen();
    } else {
      document.documentElement.requestFullscreen();
    }
    setIsFullScreen(!isFullScreen);
  };

  // Logout confirmation handling
  const confirmLogOut = () => {
    navigate("/");
    localStorage.clear();
  };

  const confirmLogOutpopupClose = () => {
    setIsLogoutOpenPopup(false);
  };

  const userType = localStorage.getItem("Loginusertype");
  const isAdmin = userType === "Administration";

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarNav">
        <img
          id="clsslogo"
          src={CLSSlogo}
          className="rounded-circle"
          width="40"
          height="28"
          alt="Logo"
          loading="lazy"
        />

        <ul className="navbar-nav">
          <li className="nav-item" hidden={!isAdmin}>
            <NavLink id="num" to="/masterLayout">
              Administration
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="num" to="/library">
              Library
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink id="num" to="/playlist">
              Playlist
            </NavLink>
          </li>
          <li className="nav-item" id="schedulealignment">
            <NavLink id="num" to="/schedule">
              Schedule
            </NavLink>
          </li>
          <li className="nav-item">
            <NavLink
              id="num"
              to="/reportTree"
              className={
                isActive("/report") || isActive("/scheduleInfo")
                  ? "active"
                  : "inactive"
              }
            >
              Report
            </NavLink>
          </li>
        </ul>
      </div>

      <div className="userNimage">
        {/* Display Channel Name */}
        <b style={{ marginTop: "5px", color: "lightslategray" }}>
          {localStorage.getItem("ChannelName")}
        </b>

        {/* Channel Switch Icon */}
        <i
          id="SwitchChannelicon"
          className="fa fa-table"
          onClick={SwithChannel}
          title="Switch Channel"
          style={{
            marginTop: "7px",
            fontSize: "22px",
            color: "lightslategray",
            cursor: "pointer",
          }}
        ></i>

        {/* Fullscreen Toggle Icon */}
        <i
          className={`pi ${
            isFullScreen ? "pi-window-minimize" : "pi-window-maximize"
          }`}
          onClick={toggleFullScreen}
          style={{
            marginTop: "8px",
            fontSize: "18px",
            color: "lightslategray",
            cursor: "pointer",
          }}
          title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
        ></i>

        {/* Username Display */}
        <b className="userName">{getlocalstorageusername}</b>

        {/* User Profile Picture */}
        <div className="userContainer">
          <div className="nav-item dropdown" style={{ marginTop: "4px" }}>
            <a
              className="nav-link"
              href="#"
              role="button"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQBLE2R35SV62Enw03QHS5AY-LUr6HOhmHvrA&usqp=CAU"
                width="25"
                height="25"
                className="rounded-circle"
                title="User Profile"
              />
            </a>
          </div>
        </div>

        {/* Log Out Icon */}
        <i
          style={{
            right: "15px",
            fontSize: "20px",
            position: "relative",
            top: "8px",
            cursor: "pointer",
            color: "lightslategray",
          }}
          className="fa fa-power-off"
          onClick={LogOutButton}
          title="LogOut"
        />

        {/* Logout Confirmation Popup */}
        <GlobalPopup
          title={"Confirmation"}
          visible={isLogoutOpenPOpup}
          onHide={confirmLogOutpopupClose}
          content={
            <>
              <br />
              <h6>Do you want to Exit ...?</h6>
              <div className="dialogeBox">
                <Button
                  id="Dialog_Yes"
                  label="Yes"
                  icon="pi pi-check"
                  onClick={confirmLogOut}
                  autoFocus
                />
                <Button
                  id="Dialog_Cancel"
                  label="Cancel"
                  icon="pi pi-times"
                  onClick={confirmLogOutpopupClose}
                  className="p-button-text"
                />
              </div>
            </>
          }
        />
      </div>
    </nav>
  );
}
